import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "authLayout" }
const _hoisted_2 = { class: "authLayout_wrapper" }
const _hoisted_3 = { class: "authLayout_preHeader" }
const _hoisted_4 = { class: "authLayout_header" }
const _hoisted_5 = { class: "authLayout_header_logo" }
const _hoisted_6 = { class: "authLayout_header_title" }
const _hoisted_7 = { class: "authLayout_header_description" }
const _hoisted_8 = { class: "authLayout_content" }
const _hoisted_9 = {
  key: 0,
  class: "authLayout_agreement"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "authLayout_support -mobile" }
const _hoisted_13 = { class: "authLayout_support_tip" }

import { computed, ref } from 'vue'
import { MqResponsive } from 'vue3-mq'
import { useStore } from '@web/store'

import AcModal from '@ui-kit/components/AcModal.vue'
import AuthSupportModalContent from '@web/platform.v3/components/auth/support-modal-content.vue'
import AnyLogo from '@web/platform.v3/components/AnyLogo.vue'
import TakeLogo from '@web/platform.v3/components/TakeLogo.vue'

import getBaseUrl from '@web/common/getBaseUrl'
import { specialProjectId } from '@web/common/ExternalConfig/getters'
import { useRoute, useRouter } from 'vue-router'
import useLoginForm from '@web/composition/useLoginForm'
import { useMeta } from '@web/common/vueMeta'
import PAGE_NAME from '@web/consts/PAGE_NAME'
import i18n from '@web/plugins/i18n'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AuthLayoutV3'
},
  __name: 'auth',
  props: {
  showAgreement: {
    type: Boolean,
    default: true
  },
  showSupport: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {





const router = useRouter()
useLoginForm({
  router,
  serverErrors: {},
  displayServerErrors: () => [],
  isLoadDataAfterSuccessLogin: false
})

const store = useStore()
store.dispatch('authV3/getCachedAuthOptions')

const route = useRoute()

const titleKeyByRoute: Record<string, string> = {
  [PAGE_NAME.LOGIN]: 'auth.pageTitle.login',
  [PAGE_NAME.PHONE_VERIFICATION]: 'auth.pageTitle.phoneVerification',
  [PAGE_NAME.UPDATE_PROFILE]: 'auth.pageTitle.updateProfile'
}

useMeta({
  title: computed(() => {
    const key = titleKeyByRoute[route.name as string]
    return key ? i18n.global.t(key) : ''
  })
})

const projectId = computed(() => specialProjectId())
const componentLogo = computed(() => {
  if (projectId.value === 'take') {
    return TakeLogo
  }
  return AnyLogo
})

const isShowSupportModal = ref(false)

const termsAgreementLink = computed(() => getBaseUrl('/docs/terms_of_use.pdf'))
const personalDataAgreementLink = computed(() => getBaseUrl('/docs/personal_data_agreement.pdf'))

const handlerSupportButton = () => {
  isShowSupportModal.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "preHeader")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(componentLogo.value)))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "title")
        ]),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "description")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (__props.showAgreement)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.$t('auth.agreement.part1')) + " ", 1),
            _createElementVNode("a", {
              class: "authLayout_agreement_link",
              href: termsAgreementLink.value
            }, _toDisplayString(_ctx.$t('auth.agreement.part2')), 9, _hoisted_10),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('auth.agreement.part3')) + " ", 1),
            _createElementVNode("a", {
              class: "authLayout_agreement_link",
              href: personalDataAgreementLink.value
            }, _toDisplayString(_ctx.$t('auth.agreement.part4')), 9, _hoisted_11)
          ]))
        : _createCommentVNode("", true),
      (__props.showSupport)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(MqResponsive), { target: "mobile" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('auth.needHelp')), 1),
                  _createElementVNode("div", {
                    class: "authLayout_support_link",
                    onClick: handlerSupportButton
                  }, _toDisplayString(_ctx.$t('contactSupport')), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(MqResponsive), { target: "tablet-desktop" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "authLayout_support",
                  onClick: handlerSupportButton
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("svg", {
                    width: "52",
                    height: "52",
                    viewBox: "0 0 52 52",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("rect", {
                      width: "52",
                      height: "52",
                      rx: "26",
                      fill: "#A990E2"
                    }),
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M37.4283 23.452C36.9854 19 34.2997 12 25.9999 12C17.7 12 15.0143 19 14.5714 23.452C13.0179 24.0298 11.9931 25.4916 12 27.12V29.08C12 31.245 13.7909 33 16 33C18.2091 33 20 31.2449 20 29.08V27.12C19.9927 25.5267 19.0057 24.095 17.4999 23.494C17.7857 20.918 19.1857 14.8 25.9999 14.8C32.8141 14.8 34.1998 20.918 34.4855 23.494C32.9828 24.0963 32.0007 25.529 31.9998 27.12V29.08C32.0029 29.8176 32.2175 30.5395 32.6191 31.1633C33.0207 31.7871 33.5932 32.2877 34.2712 32.608C33.6712 33.714 32.1426 35.212 28.3855 35.66C27.6345 34.5424 26.1815 34.1018 24.9176 34.6084C23.6538 35.1151 22.9324 36.4274 23.196 37.7404C23.4596 39.0534 24.6344 40 25.9999 40C26.529 39.9971 27.0469 39.8503 27.4958 39.5759C27.9448 39.3015 28.3072 38.9104 28.5427 38.446C34.6712 37.76 36.6283 34.666 37.2426 32.846C38.9044 32.3184 40.0221 30.7918 39.9997 29.08V27.12C40.0066 25.4916 38.9818 24.0298 37.4283 23.452ZM17.1428 29.08C17.1428 29.6985 16.6312 30.2 16 30.2C15.3688 30.2 14.8572 29.6986 14.8572 29.08V27.12C14.856 26.9722 14.8847 26.8256 14.9416 26.6887C14.9985 26.5519 15.0825 26.4274 15.1888 26.3225C15.295 26.2176 15.4214 26.1343 15.5606 26.0775C15.6998 26.0206 15.8492 25.9914 16 25.9914C16.1508 25.9914 16.3001 26.0206 16.4394 26.0775C16.5786 26.1343 16.705 26.2176 16.8112 26.3225C16.9174 26.4274 17.0014 26.5519 17.0584 26.6887C17.1153 26.8256 17.144 26.9722 17.1428 27.12V29.08ZM34.8569 27.12C34.8569 26.5014 35.3685 26 35.9997 26C36.6309 26 37.1426 26.5014 37.1426 27.12V29.08C37.1426 29.6985 36.6309 30.2 35.9997 30.2C35.3685 30.2 34.8569 29.6986 34.8569 29.08V27.12Z",
                      fill: "white"
                    })
                  ], -1)
                ]))])
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (isShowSupportModal.value)
      ? (_openBlock(), _createBlock(AcModal, {
          key: 0,
          modelValue: isShowSupportModal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShowSupportModal).value = $event)),
          "mobile-modal-type": "bottomSheet"
        }, {
          default: _withCtx(() => [
            _createVNode(AuthSupportModalContent, {
              onClose: _cache[0] || (_cache[0] = ($event: any) => (isShowSupportModal.value = false))
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})